<!-- Title, export and the period buttons, as on the maps field panel's NDVI card. -->
<div class="flex flex-wrap items-center gap-2">
  <span class="field-analysis-header">NDVI Index</span>
  <button *ngIf="hasData && !loading" type="button" (click)="exportChart()" title="Export chart as image" aria-label="Export chart as image"
          class="flex h-8 w-8 items-center justify-center rounded-md text-[var(--base-text-alt-dark)] hover:bg-[var(--app-hover)] hover:text-[var(--primary-dark)]">
    <span class="material-icons text-[18px]!" aria-hidden="true">download</span>
  </button>
  <span class="flex-1"></span>
  <div class="flex gap-[3px] rounded-lg bg-[var(--app-hover)] p-[2px]" role="group" aria-label="NDVI period">
    <!-- Period: the season or dates at the top of the page, which the chart follows unless overridden. -->
    <button type="button" (click)="followPage()" [disabled]="!page" [attr.aria-pressed]="activeRange === null"
            [title]="page ? 'The period at the top: ' + page.from + ' to ' + page.to : 'The period at the top'"
            class="rounded-md px-2.5 py-1 text-xs font-semibold disabled:opacity-50"
            [ngClass]="activeRange === null ? 'bg-[var(--app-surface)] text-[var(--primary-dark)] shadow-sm' : 'text-[var(--base-text-alt-dark)]'">
      Period
    </button>
    <button *ngFor="let range of quickRanges" type="button" (click)="setRange(range)" [attr.aria-pressed]="activeRange === range"
            class="rounded-md px-2.5 py-1 text-xs font-semibold"
            [ngClass]="activeRange === range ? 'bg-[var(--app-surface)] text-[var(--primary-dark)] shadow-sm' : 'text-[var(--base-text-alt-dark)]'">
      {{ range }}M
    </button>
    <button type="button" (click)="setRange(0)" [attr.aria-pressed]="activeRange === 0"
            class="rounded-md px-2.5 py-1 text-xs font-semibold"
            [ngClass]="activeRange === 0 ? 'bg-[var(--app-surface)] text-[var(--primary-dark)] shadow-sm' : 'text-[var(--base-text-alt-dark)]'">
      All
    </button>
  </div>
</div>

<!-- Min / Avg / Max for the period -->
<div *ngIf="!loading && stats" class="mt-3 flex gap-2" data-ndvi-stats>
  <span class="flex flex-1 items-center justify-center gap-1.5 rounded-md border border-[var(--app-border)] bg-[var(--app-base)] px-2 py-1">
    <i class="h-2 w-2 rounded-full bg-[#663333]"></i>
    <span class="text-[10px] font-bold uppercase tracking-wide text-[var(--base-text-alt-dark)]">Min</span>
    <span class="text-sm font-bold tabular-nums">{{ stats.min | number:'1.2-2' }}</span>
  </span>
  <span class="flex flex-1 items-center justify-center gap-1.5 rounded-md border border-[var(--app-border)] bg-[var(--app-base)] px-2 py-1">
    <i class="h-2 w-2 rounded-full bg-[#8dc63f]"></i>
    <span class="text-[10px] font-bold uppercase tracking-wide text-[var(--base-text-alt-dark)]">Avg</span>
    <span class="text-sm font-bold tabular-nums">{{ stats.avg | number:'1.2-2' }}</span>
  </span>
  <span class="flex flex-1 items-center justify-center gap-1.5 rounded-md border border-[var(--app-border)] bg-[var(--app-base)] px-2 py-1">
    <i class="h-2 w-2 rounded-full bg-[#0000CC]"></i>
    <span class="text-[10px] font-bold uppercase tracking-wide text-[var(--base-text-alt-dark)]">Max</span>
    <span class="text-sm font-bold tabular-nums">{{ stats.max | number:'1.2-2' }}</span>
  </span>
</div>

<div *ngIf="loading" class="flex h-[300px] items-center justify-center">
  <span class="material-icons animate-spin text-[28px] text-[var(--app-border)]" aria-hidden="true">autorenew</span>
</div>
<div *ngIf="!loading && failed" class="flex h-[300px] items-center justify-center">
  <p class="text-base text-[var(--base-text-alt-dark)]">Could not load NDVI for this field</p>
</div>
<div *ngIf="!loading && !failed && !hasData" class="flex h-[300px] items-center justify-center">
  <p class="text-base text-[var(--base-text-alt-dark)]">No NDVI data available for the selected period</p>
</div>
<!-- All is taller to fit its timeline slider -->
<div *ngIf="!loading && hasData" echarts [options]="chartOption" [autoResize]="true" (chartInit)="onChartInit($event)"
     class="w-full max-w-full" [ngClass]="activeRange === 0 ? 'h-[340px]' : 'h-[300px]'"></div>

<p *ngIf="!loading && hasData" class="mt-1 text-center text-xs font-medium tabular-nums text-[var(--base-text-alt-dark)]" data-ndvi-period>
  {{ fromDate }} → {{ toDate }}
</p>
